import React from 'react'
import { useDispatch } from 'react-redux'

// Redux slices
import { openModal } from '../../appSlice'

// SemanticUI components 
import { Icon, Table, Label, CardMeta, CardDescription, CardContent, Button, Card } from 'semantic-ui-react'

// Actions
import { doContractAction } from "./contractSlice";

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Styles
import './contract.css';


registerLocale('de', de);
setDefaultLocale('de');


/**
 * 
 * @param {bool} editMode 
 * @param {Object} Extra 
 * @returns 
 */
const Max2ContractSpecialsPreview = ({editMode, extra}) => {
  // global State
  const dispatch = useDispatch();

  // Edit mode?
  const readOnly = editMode ? false : true;

  // current date
  const today = new Date();

  // Detail Value
  let detailValue = <></>
  switch (extra.ExtraType) {
    case 'Early Booking Special': detailValue = extra.Value + ' ' + extra.ValueType.replace('DAY', '€/Tag').replace('WEEK', '€/Woche').replace('FIX', '€'); break;
    case 'Special Supplement': detailValue = ''; break;
    case 'Free Night Special': detailValue = ''; break;
    case 'Special Reduction': detailValue = ''; break;
    case 'Additional Costs': detailValue = ''; break;
    case 'Special Rate': detailValue = ''; break;
    default: detailValue = '';
  }

  // Detail Dates
  let outdated = true;
  const dates = extra.Restrictions?.Dates.map((date) => {
    const start = date.Period?.Start ? format(new Date(date.Period.Start), 'dd.MM') : '';
    const end = date.Period?.End ? format(new Date(date.Period?.End), 'dd.MM.yyyy') : '';

    // check if extra is outdated
    if (parseInt(format(new Date(date.Period?.End), 'yyyyMMdd')) > parseInt(format(today, 'yyyyMMdd'))) {
      outdated = false;
    }

    return <><span>{start} - {end}</span><br /></>
  });

  // Detail Bookings
  const bookingStart = extra.Restrictions?.Bookings[0]?.Period?.Start ? format(new Date(extra.Restrictions.Bookings[0].Period.Start), 'dd.MM') : '';
  const bookingEnd = extra.Restrictions?.Bookings[0]?.Period?.End ? format(new Date(extra.Restrictions?.Bookings[0]?.Period?.End), 'dd.MM.yyyy') : '';

  // Detail Rooms
  const rooms = extra.Restrictions?.Rooms.map((room) => {
    return <span>{room}&nbsp;&nbsp;</span>
  });

  // label color
  const labelColor = extra.ExtraId === '__NEW__' ? 'green' :  outdated ? 'grey' : 'blue'; 

  // 
  const cardContent = (
    <CardContent>
      <Label color={labelColor} ribbon='right'>
        {extra.ExtraId}
      </Label>
      <CardDescription style={{marginBottom: '10px', marginTop: '-20px'}}>{dates}</CardDescription>
      {extra.ExtraText && (
        <CardMeta>
          {extra.ExtraText}
        </CardMeta>
      )}
      <CardDescription>
        <Table basic='very'>
          {detailValue && (
            <Table.Row>
              <Table.Cell style={{borderTop: 'none', padding: '4px', color: 'rgba(0, 0, 0, .4)'}} textAlign='right'>Wert:</Table.Cell>
              <Table.Cell style={{borderTop: 'none', padding: '4px'}}>{detailValue}</Table.Cell>
            </Table.Row>
          )}
          <Table.Row>
            <Table.Cell style={{borderTop: 'none', padding: '4px', color: 'rgba(0, 0, 0, .4)'}} textAlign='right'>Buchbar von/bis:</Table.Cell>
            <Table.Cell style={{borderTop: 'none', padding: '4px'}}>{bookingStart} - {bookingEnd}</Table.Cell>
          </Table.Row>
          {rooms && (
            <Table.Row>
              <Table.Cell style={{borderTop: 'none', padding: '4px', color: 'rgba(0, 0, 0, .4)'}} textAlign='right'>Zimmer:</Table.Cell>
              <Table.Cell style={{borderTop: 'none', padding: '4px'}}>{rooms}</Table.Cell>
            </Table.Row>
          )}
        </Table>
      </CardDescription>
    </CardContent>
  )

  if (readOnly) {
    return (
      <Card link style={{marginRight: '15px'}} onClick={()=>dispatch(openModal({type: 'special', editMode: false, data: extra}))}>
        {cardContent}
      </Card>
    );
  } else {
    return (
      <Card link style={{marginRight: '15px'}}>
        {cardContent}
        <CardContent extra>
          <Button basic circular icon floated='right' onClick={()=>dispatch(doContractAction({target: 'Special.copy', value: extra.ExtraId}))}><Icon name='copy' /></Button>
          <Button basic circular icon floated='right' onClick={()=>dispatch(openModal({type: 'special', editMode: editMode, data: extra}))}><Icon name='edit' /></Button>
          <Button basic circular icon floated='right' onClick={()=>dispatch(doContractAction({target: 'Special.remove', value: extra.ExtraId}))}><Icon name='trash' /></Button>
        </CardContent>
      </Card>
    );
  }
}

export default Max2ContractSpecialsPreview;
